module.exports = __webpack_public_path__ + "static/img/no3.5ef8d6e2.png";